import React from 'react';

import {Stack, Typography} from '@mui/material';
import {t} from 'i18next';

import {useAppSelector} from 'hooks';
import {useBasketCalculations} from 'hooks/useBasketCalculations';
import {formatPriceWithCurrency} from 'utils/currency';

const BasketDeliveryFee: React.FC = () => {
  const {basket} = useAppSelector((state) => state?.basket) || {};
  const {priceUnit} = useBasketCalculations();
  const prices = basket?.prices;

  if (!prices) {
    return null;
  }

  const originalShippingFee = prices?.shippingFee;

  return (
    <Stack direction="row" spacing={1}>
      {(prices.originalShippingFee || 0) > prices.shippingFee && (
        <Typography fontSize="inherit" fontWeight="inherit" style={{textDecoration: 'line-through'}}>
          {formatPriceWithCurrency(prices.originalShippingFee || 0, priceUnit)}
        </Typography>
      )}

      <Typography fontSize="inherit" fontWeight="inherit">
        {originalShippingFee === 0 && basket.basketItems.length > 0 ? (
          <Typography color="primary" sx={{fontWeight: 'bold'}}>
            {t('label.free')}
          </Typography>
        ) : (
          formatPriceWithCurrency(originalShippingFee, priceUnit)
        )}
      </Typography>
    </Stack>
  );
};

BasketDeliveryFee.displayName = 'BasketDeliveryFee';
export default BasketDeliveryFee;
